import React from "react";
import enterpriseImg from "../../../assets/home/img_home.png";

const features = [
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/>
      </svg>
    ),
    text: "Centralised GST invoicing & billing for zero-hassle expense management",
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
    text: "Priority cab booking for executives, leadership teams & corporate events",
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
    ),
    text: "Dedicated relationship manager for end-to-end corporate travel support",
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    text: "Live trip tracking & employee safety monitoring for every business ride",
  },
];

const stats = [
  { value: "500+", label: "Companies Served" },
  { value: "50K+", label: "Business Trips" },
  { value: "100%", label: "GST Compliant" },
];

const StatisticSection = () => {
  return (
    <section className="enterprise" aria-labelledby="enterprise-heading">
      <div className="enterprise__container">

        {/* LEFT CONTENT */}
        <div className="enterprise__content">
          <span className="enterprise__tag">CORPORATE TRAVEL</span>

          <h2 className="enterprise__title" id="enterprise-heading">
            Corporate Cab Booking for{" "}
            <span className="enterprise__title--highlight">Businesses & Enterprises</span>
          </h2>

          <p className="enterprise__subtitle">
            Simplify company travel with Pulpit — India's trusted corporate cab service built for reliability, transparency, and scale.
          </p>

          <ul className="enterprise__list">
            {features.map((f, i) => (
              <li key={i} className="enterprise__list-item">
                <span className="enterprise__list-icon">{f.icon}</span>
                <span>{f.text}</span>
              </li>
            ))}
          </ul>

          <div className="enterprise__stats">
            {stats.map((s, i) => (
              <React.Fragment key={i}>
                {i > 0 && <div className="enterprise__stats-divider" />}
                <div className="enterprise__stat">
                  <strong className="enterprise__stat-value">{s.value}</strong>
                  <span className="enterprise__stat-label">{s.label}</span>
                </div>
              </React.Fragment>
            ))}
          </div>

          <div className="enterprise__actions">
            <a href="/business" className="enterprise__btn enterprise__btn--primary">
              Contact Sales
            </a>
            <a href="/business" className="enterprise__btn enterprise__btn--ghost">
              Learn More
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
              </svg>
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="enterprise__image">
          <img
            src={enterpriseImg}
            alt="Corporate cab service for business travel — Pulpit Enterprise"
            loading="lazy"
          />
        </div>

      </div>
    </section>
  );
};

export default StatisticSection;
